import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import {
  AbcArenaComponent,
  CRUDPermissions,
  LayoutUsage,
  LoadLayoutStatus,
  IArenaPlugin,
  AdditionalHigonAction,
  AdditionalMenuSettingItem,
} from '@barthauer/abc/arena';
import { PropertyDocumentSource } from '@barthauer/abc/common-editors';
import { ICoreDataEntity } from '@barthauer/abc/core/data';
import { Observable } from 'rxjs';

@Component({
  selector: 'basys-lib-arena',
  template: `<abc-arena
    #abcArena
    [renderNavigation]="renderNavigation"
    [renderMenu]="renderMenu"
    [renderDataForm]="renderDataForm"
    [renderHigna]="renderHigna"
    [renderHigon]="renderHigon"
    [arenaName]="arenaName"
    [renderHeader]="renderHeader"
    [renderHignaButtons]="renderHignaButtons"
    [renderDrawer]="renderDrawer"
    [isStandaloneDataForm]="isStandaloneDataForm"
    [layoutUsage]="layoutUsage"
    [defaultObjectType]="defaultObjectType"
    [additionalHigonActions]="additionalHigonActions"
    [additionalMenuSettingItems]="additionalMenuSettingItems"
    [plugins]="plugins"
    [propertyDocumentSource]="propertyDocumentSource"
    [crudPermissions]="crudPermissions"
    [disableNotification]="disableNotification"
    [helpUrl]="helpUrl"
    (onObjectsSelected)="objectsSelected($event)"
  >
  </abc-arena> `,
  styles: [],
  standalone: false,
})
export class BasysArenaComponent implements OnInit, OnDestroy {
  @ViewChild('abcArena', { static: true }) public abcArena: AbcArenaComponent;
  @Input() renderNavigation = true;
  @Input() renderMenu = true;
  @Input() renderDataForm = true;
  @Input() renderHigna = true;
  @Input() renderHigon = true;
  @Input() arenaName: string;
  @Input() renderHeader = true;
  @Input() renderHignaButtons: boolean = false;
  @Input() renderDrawer = true;
  @Input() isStandaloneDataForm = false;
  @Input() propertyDocumentSource: PropertyDocumentSource;
  @Input() crudPermissions: CRUDPermissions;

  private _additionalHigonActions: AdditionalHigonAction[];
  @Input()
  get additionalHigonActions() {
    return this._additionalHigonActions;
  }
  set additionalHigonActions(actions) {
    this._additionalHigonActions = actions;
  }
  private _additionalMenuSettingItems: AdditionalMenuSettingItem[];
  @Input()
  get additionalMenuSettingItems() {
    return this._additionalMenuSettingItems;
  }
  set additionalMenuSettingItems(actions) {
    this._additionalMenuSettingItems = actions;
  }
  private _plugins: IArenaPlugin[];
  @Input()
  get plugins(): IArenaPlugin[] {
    return this._plugins;
  }
  set plugins(plugins: IArenaPlugin[]) {
    this._plugins = plugins;
  }
  @Input() layoutUsage: LayoutUsage = LayoutUsage.Standard;
  @Input() defaultObjectType: string | number;
  @Input() disableNotification: boolean;
  @Input() helpUrl: string;
  @Output() onObjectsSelected: EventEmitter<ICoreDataEntity[]> = new EventEmitter();
  public beforeLogoutFunc: () => void;

  constructor() {}
  ngOnDestroy(): void {
    // this.abcArena.ngOnDestroy();
  }
  ngOnInit() {
    if (!this.propertyDocumentSource) {
      this.propertyDocumentSource = new PropertyDocumentSource();
      this.propertyDocumentSource.objectSpaceName = '';
      this.propertyDocumentSource.objectType = 'GemeindeVariante';
      this.propertyDocumentSource.opath = 'Id=$CurrentMunicipalityVariantId';
    }
    this.abcArena.beforeLogoutFunc = this.beforeLogoutFunc;
  }

  arenaStatus(): Observable<LoadLayoutStatus> {
    return this.abcArena.arenaStatus$;
  }

  objectsSelected(dataEntities: ICoreDataEntity[]) {
    this.onObjectsSelected.emit(dataEntities);
  }

  openLayoutByObjectType(arenaName: string, objectType: number | string, idList: string[]) {
    this.abcArena.openLayoutByObjectType(arenaName ?? this.arenaName, objectType, idList);
  }

  openLayoutByPath(arenaName: string, layoutPath: string, idList?: string[]) {
    this.abcArena.openLayoutByPath(arenaName ?? this.arenaName, layoutPath, idList);
  }

  openNavigationGroup(groupName: string) {
    this.abcArena.openNavigationGroupByName(groupName);
  }
}
